import React from "react";
import { Card, Badge, Button } from "antd";
import ShowOverride from "./ShowOverride";
import EditOverride from "./EditOverrideButton";
import DeleteOverride from "./DeleteOverrideButton";
import { Grid } from "@material-ui/core";

export const OverrideCard = ({ item }) => {
  return (
    <Card
      title={<Badge status="processing" text={item.name} />}
      style={{
        marginBottom: 15,
        minWidth: 300,
        boxShadow: "1px 1px 1px #9E9E9E",
        borderRadius: "5px",
      }}
      bordered={true}
      actions={[
        <ShowOverride item={item} key="view" />,
        <EditOverride item={item} key="edit" />,
        <DeleteOverride item={item} key="delete" />,
      ]}
    >
      <Grid container direction="column" justify="center" alignItems="center">
        <h1>{item.name}</h1>
      </Grid>
    </Card>
  );
};

export default OverrideCard;
